import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Container from '@mui/material/Container';

import home1 from '../media/Home/Gallery/home1.JPG';
import home2 from '../media/Home/Gallery/home2.JPG';
import home3 from '../media/Home/Gallery/home3.JPG';
import home4 from '../media/Home/Gallery/home4.JPG';
import home5 from '../media/Home/Gallery/home5.JPG';

import home7 from '../media/Home/Gallery/home7.JPG';
import home8 from '../media/Home/Gallery/home8.JPG';
import home9 from '../media/Home/Gallery/home9.JPG';
import home11 from '../media/Home/Gallery/home11.JPG';
import home15 from '../media/Home/Gallery/home15.JPG';
import home17 from '../media/Home/Gallery/home17.JPG';
import home18 from '../media/Home/Gallery/home18.JPG';
import home19 from '../media/Home/Gallery/home19.JPG';
import home20 from '../media/Home/Gallery/home20.JPG';
import home21 from '../media/Home/Gallery/home5.JPG';
import home25 from '../media/Home/Gallery/home25.JPG';



export default function HomeGallery() {
  return (
    <>
        <ImageList sx={{ width: '100%', height: '100%' }} variant="woven" cols={3} gap={8}>
        {itemData.map((item) => (
            <ImageListItem key={item.img}>
            <img
                srcSet={`${item.img}?w=161&fit=crop&auto=format&dpr=2 2x`}
                src={`${item.img}?w=161&fit=crop&auto=format`}
                alt={item.title}
                loading="lazy"
            />
            </ImageListItem>
        ))}
        </ImageList>
    </>
  );
}

const itemData = [
  {
    img: home1,
    title: 'home1',
  },
  {
    img: home2,
    title: 'home2',
  },
  {
    img: home3,
    title: 'home3',
  },
  {
    img: home4,
    title: 'home4',
  },
  {
    img: home5,
    title: 'home5',
  },
  {
    img: home7,
    title: 'home7',
  },
  {
    img: home8,
    title: 'home8',
  },
  {
    img: home9,
    title: 'home9',
  },
  {
    img: home11,
    title: 'home11',
  },
  {
    img: home15,
    title: 'home15',
  },
  {
    img: home17,
    title: 'home17',
  },
  {
    img: home18,
    title: 'home18',
  },
  {
    img: home19,
    title: 'home19',
  },
  {
    img: home20,
    title: 'home20',
  },
  // {
  //   img: home21,
  //   title: 'home21',
  // },
  {
    img: home25,
    title: 'home25',
  },
];